<template>
  <CContainer>
    <h3>Formulario Producto Contrato de Arrendamiento</h3>
    <CCard class="mt-4">
      <CCardBody>
        <CForm>
          <CRow>
            <CCol col="sm-12">
              <CAutocomplete 
                label="Producto:" 
                required 
                :options="products" 
                :value.sync="rentedProduct['producto']"
                @update-search="value => getListProducts(value)"
                @update:input="newValue => {
                  rentedProduct['producto'] = newValue;
                  validate();
                }">
              </CAutocomplete>
            </CCol>
            <CCol col="sm-3">
              <label class="text-muted font-weight-bold">Fecha Entrega:</label>
              <DatePicker 
                v-model="rentedProduct['fecha_Entrega']" 
                type="date" 
                value-type="YYYY-MM-DD"
                format="DD/MM/YYYY" 
                placeholder="dd/mm/aaaa" 
                @close="validate" />
            </CCol>
            <CCol col="sm-2">
              <CInput 
                label="Cantidad:" 
                addLabelClasses="text-muted font-weight-bold" 
                min="1" 
                type="number"
                :value="rentedProduct['cantidad']" @input="newValue => {
                  rentedProduct['cantidad'] = newValue;
                  rentedProduct['numero_Serial'] = newValue > 1 ? '' : rentedProduct['numero_Serial'];
                  validate();
                }" />
            </CCol>
            <CCol col="sm-3">
              <CInput 
                label="Valor:" 
                required 
                addLabelClasses="text-muted font-weight-bold"
                :value.sync="rentedProduct['valor_Arriendo']" 
                @input="() => {
                  validate();
                }" />
            </CCol>
            <CCol col="sm-4">
              <CInput 
                label="Número Serial:" 
                addLabelClasses="text-muted font-weight-bold"
                :disabled="rentedProduct['cantidad'] > 1" 
                :value.sync="rentedProduct['numero_Serial']" />
            </CCol>
            <CCol col="sm-12">
              <CInput 
                label="Descripción:" 
                addLabelClasses="text-muted font-weight-bold"
                :value.sync="rentedProduct['descripcion']" />
            </CCol>
            <CCol col="sm-6">
              <label class="text-muted font-weight-bold">Estado:</label>
              <CSwitch 
                color="dark" 
                shape="pill" 
                variant="opposite" 
                class="align-middle mx-2"
                :checked.sync="rentedProductStatus" 
                @update:checked="nvalue => {
                  rentedProduct['estado'] = nvalue ? 'A' : 'I';
                }" />
              <span class="font-weight-bold">{{ rentedProduct['estado'] === 'A' ? 'Activo' : 'Inactivo' }}</span>
            </CCol>
            <CCol col="sm-6">
              <label class="text-muted font-weight-bold">Activa Componentes:</label>
              <CSwitch 
                color="dark" 
                shape="pill" 
                variant="opposite" 
                class="align-middle mx-2"
                :checked.sync="activateComponents" 
                @update:checked="value => {
                  rentedProduct['activa_Componentes'] = value ? 'V' : 'F';
                }" />
            </CCol>
          </CRow>
        </CForm>
      </CCardBody>
      <CCardFooter>
        <div class="d-flex justify-content-center">
          <CButton 
            color="success" 
            class="mr-2" 
            :class="isValidForm ? '' : 'disabled'"
            :disabled="!isValidForm" 
            @click="saveRentedProduct()">
            <CIcon name="cil-check-circle" class="mr-2" />
            <span class="align-middle">Guardar</span>
          </CButton>
          <CButton 
            color="danger" 
            variant="outline" 
            class="mr-2"
            :to="rootPath">
            <CIcon name="cil-x-circle" class="mr-2" />
            <span class="align-middle">Cancelar</span>
          </CButton>
        </div>
      </CCardFooter>
    </CCard>

    <LoadingCover v-show="loading" />
  </CContainer>
</template>
<script>
  import { ref } from "vue";
  import "vue2-datepicker/index.css"
  import DatePicker from "vue2-datepicker"

  import CONSTANTS from "@/constants";
  // import { obtenerProducto } from "@/api";
  import { searchProducto } from "@/apiDataSearch";
  import { crudProductoArrendamiento } from "@/apis/rents";

  import CAutocomplete from "@/components/containers/CAutocomplete.vue";
  import LoadingCover from "@/components/containers/LoadingCover.vue";

  export default ({
    name: "RentedProductForm",
    data() {
      return {
        CONSTANTS,
        loading: false,
        isCreate: false,
        isValidForm: false,
        requiredFields: ["fecha_Entrega", "valor_Arriendo"],
        products: [],
        rentedProduct: {
          contrato_Arrendamiento: "",
          producto: "",
          fecha_Entrega: "",
          cantidad: 1,
          valor_Arriendo: 0,
          descripcion: "",
          numero_Serial: "",
          activa_Componentes: "V",
          estado: "A"
        },
        rentedProductId: '',
        rentContractIndex: '',
        rentedProductStatus: true,
        activateComponents: false
      }
    },
    components: {
      DatePicker,
      LoadingCover,
      CAutocomplete
    },
    methods: {
      async getListProducts(value) {
        if (value.length > 2) {
          try {
            const response = await searchProducto(this, value);

            this.products = response.map(item => {
              return {
                value: item.id_Producto,
                label: `${item.codigo} - ${item.descripcion}`
              }
            });
          } catch (error) {
            console.log(error);
          }
        }
      },
      validate() {
        this.isValidForm = this.requiredFields.reduce((acc, key) => {
          return acc && (this.rentedProduct[key].length > 0)
        }, true)
      },
      async getRentedProductData(id) {
        try {
          const { response } = await crudProductoArrendamiento(this, "read", id);

          return response
        } catch {
          this.$store.commit("setAlert", {
            color: "danger",
            message: 'Error al cargar datos',
            show: 5
          });
        }
      },
      // async getProduct(productId) {
      //   try {
      //     const { response } = await obtenerProducto(this, productId)
      //     return [{
      //       value: response.id_Producto,
      //       label: `${response.codigo} - ${response.descripcion}`
      //     }];
      //   } catch (error) {
      //     console.log(error);
      //   }
      // },
      async saveRentedProduct() {
        this.loading = true

        try {
          const processData = {}

          Object.keys(this.rentedProduct).forEach(key => {
            this.rentedProduct[key] ? processData[key] = this.rentedProduct[key] : undefined
          });


          console.log("Data ", processData);
          

          if (this.isCreate) {
            await crudProductoArrendamiento(this, "create", null, processData);
          } else {
            await crudProductoArrendamiento(this, "update", this.rentedProductId, processData);
          }

          this.$store.commit("setAlert", {
            color: "success",
            message: CONSTANTS.messages.successfulAction,
            show: 5
          });

          this.$router.push({ path: this.rootPath });
        } catch (error) {
          console.log(error);
          
          this.$store.commit("setAlert", {
            color: "danger",
            message: `NO se pudo grabar el registro. Error: ${error.status} - ${error.statusText}`,
            show: 5
          });
        } finally {
          this.loading = false;
        }
      }
    },
    setup() {
      const rootPath = ref("");

      return {
        rootPath
      }
    },
    async mounted() {
      const params_id = this.$router.currentRoute.params.id;
      const action = this.$router.currentRoute.fullPath.split("/").at(-1);

      this.rootPath = this.$router.currentRoute.fullPath.replace(`/${action}`, "");
      this.rentedProductId = params_id;
      this.isCreate = action === "agregar" ? true : false;

      if (this.isCreate) [
        this.rentedProduct["contrato_Arrendamiento"] = this.rentedProductId
      ]
    }
  })
</script>
